import { render, staticRenderFns } from "./ClientPhoneBtn.vue?vue&type=template&id=be548f38&scoped=true&"
import script from "./ClientPhoneBtn.vue?vue&type=script&lang=js&"
export * from "./ClientPhoneBtn.vue?vue&type=script&lang=js&"
import style0 from "./ClientPhoneBtn.vue?vue&type=style&index=0&id=be548f38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be548f38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
